import { Image, Pressable, View, Text, Linking } from 'react-native';
import { calcSizeForDevice } from 'utils/index';
import { Platform } from 'utils/platform';
import { useBottomSheet } from 'context/BottomSheetContext';

const LatestNews: React.FC<{ path?: string | undefined }> = ({ path }) => {
    const isMobilePlatform = ['android', 'ios'].includes(Platform.OS);
    const { handleToggleSheet, visible, setCurrentUrl } = useBottomSheet();

    const handleOpenUrl = () => {
        const url = 'https://www.band.com.br';

        if (!isMobilePlatform) {
            Linking.openURL(url).catch(err => console.error("Erro ao abrir a URL:", err));
        } else {
            !visible && handleToggleSheet(false);
            setCurrentUrl(url);
        }
    };


    return (
        <Pressable
            onPress={handleOpenUrl}
            style={{
                backgroundColor: 'transparent',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                paddingHorizontal: 5,
                paddingTop: 1,
                height: calcSizeForDevice(48, 80),
                marginVertical: calcSizeForDevice(20),
            }}>
            <View>
                <Image source={{ uri: "https://img.band.com.br/image/2025/06/04/bandiconcover-192219.png" }} style={{ width: 24, height: 24 }} alt="Últimas notícias" />
            </View>
            <Text
                style={{
                    fontFamily: 'system-ui',
                    fontSize: calcSizeForDevice(14, 20),
                    fontWeight: '400',
                    color: '#FCFCFC',
                    marginTop: calcSizeForDevice(10),
                    marginBottom: calcSizeForDevice(4)
                }}>
                Últimas notícias
            </Text>
        </Pressable>
    );
};

export default LatestNews;
